import React from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

// 1. Accept `setMenuOpen` in the component's props
function Navigation({ menuOpen, setMenuOpen }) { 

  // 2. This function will be called on every link click
  const handleLinkClick = () => {
    setMenuOpen(false); // This sets the state in the Header to 'closed'
  };

  return (
    <nav className={`main-nav ${menuOpen ? 'active' : ''}`}>
      <ul>
        {/* 3. Add the onClick handler to each list item */}
        <li onClick={handleLinkClick}><Link to="/">Home</Link></li>
        <li onClick={handleLinkClick}><Link to="/bio">Bio</Link></li>
        <li onClick={handleLinkClick}><Link to="/music">Music</Link></li>
        <li onClick={handleLinkClick}><Link to="/testimonials">Testimonials</Link></li>
        <li onClick={handleLinkClick}><Link to="/contact">Contact</Link></li>
      </ul>
    </nav>
  );
}

export default Navigation;